import styles from "./style/KeystoneManagement.module.scss";

// tone: "on" | "trial" | "off" | "pending"
const TONE_CLASS = {
  on: styles.statusOn,
  trial: styles.statusTrial,
  off: styles.statusOff,
  pending: styles.statusPending,
};

const StatusBadge = ({ tone = "off", label }) => (
  <span className={`${styles.statusBadge} ${TONE_CLASS[tone] || styles.statusOff}`}>
    <span className={styles.statusDot} />
    {label}
  </span>
);

export default StatusBadge;
